export enum PriceRequestSources {
  'am_quoting_tool' = 'Spot Quote Tool',
  'am_quoting_tool_bulk' = 'Spot Quot Tool',
  'shipper_api_new' = 'Shipper API',
  'tms_scraper' = 'TMS Scraper',
  'transfix_rates_api' = 'Transfix Rates API',
  'transfix_tmx' = 'Transfix Shipper App',
  'email_quoting_tool' = 'Email Scraper',
  'real_time_rating' = 'Transfix RTR API',
}
